import script from "./CardText.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardText.vue?vue&type=script&setup=true&lang=ts"

import "./CardText.vue?vue&type=style&index=0&id=bf988c78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf988c78"]])

export default __exports__